// Ported from range-drills-rn/src/data/getSafteyTestData.ts — keep in sync.
export const SAFETY_VIDEO_URL = 'https://range-drills.s3.us-east-2.amazonaws.com/RangeDrillsSafetyVideo.mp4';

export const safetyTest = {
  passingScore: 100, // must answer every question correctly
  questions: [
    {
      id: 1,
      question: 'Treat every firearm as if it is ______.',
      answers: [
        { text: 'Loaded', isCorrect: true },
        { text: 'Unloaded', isCorrect: false },
      ],
    },
    {
      id: 2,
      question: 'Your finger should be on the trigger ______.',
      answers: [
        { text: 'Only when your sights are on target and you are ready to shoot', isCorrect: true },
        { text: 'Anytime the gun is in your hand', isCorrect: false },
      ],
    },
    {
      id: 3,
      question: 'When dry-firing at home, you must remove ______.',
      answers: [
        { text: 'All live ammunition from the room', isCorrect: true },
        { text: 'Eye protection', isCorrect: false },
      ],
    },
    {
      id: 4,
      question: 'If your firearm malfunctions, your FIRST action should be:',
      answers: [
        { text: 'Keep the gun pointed in a safe direction and take your finger off the trigger', isCorrect: true },
        { text: 'Try to keep shooting until it works', isCorrect: false },
      ],
    },
    {
      id: 5,
      question: 'RangeDrills is NOT a substitute for ______.',
      answers: [
        { text: 'Training with a certified firearms instructor', isCorrect: true },
        { text: 'Online shopping', isCorrect: false },
      ],
    },
    {
      id: 6,
      question: 'You may use this app only if you are ______.',
      answers: [
        { text: 'Not legally prohibited from possessing or handling a firearm', isCorrect: true },
        { text: 'Comfortable with guns', isCorrect: false },
      ],
    },
  ],
  acknowledgments: [
    'I will always follow all federal, state, and local laws regarding firearms.',
    'I am not legally prohibited from possessing a firearm.',
    'I understand RangeDrills provides educational content only, not certified instruction.',
    'I am responsible for safe firearm handling at all times.',
  ],
};

// Stable shuffle so answer order varies per attempt (matches native).
export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Must be 18+ (matches native registration).
export function isAtLeast18(dobStr) {
  if (!dobStr) return false;
  const dob = new Date(dobStr);
  if (Number.isNaN(dob.getTime())) return false;
  const now = new Date();
  let age = now.getFullYear() - dob.getFullYear();
  const m = now.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) age--;
  return age >= 18;
}
